import React, { useMemo } from "react"
import ProgressBar from "@/components/common/ProgressBar"

const ParticipantCompleteProgressBar = (props) => {
    const { participantHaveRolesGroupedByRole: participants } = props

    const progress = useMemo(() => {
        return (
            participants &&
            participants.filter((participant) => {
                if (participant.questionCount) {
                    return participant.responseCount === participant.questionCount
                }
                return false
            }).length
        )
    }, [participants])

    const outOf = useMemo(() => {
        return participants && participants.length
    }, [participants])

    const progressLabel = useMemo(() => {
        return `${progress || 0} of ${outOf || 0} Participants have completed this project`
    }, [participants])

    return <ProgressBar progress={progress} outOf={outOf} label={progressLabel} />
}

export default ParticipantCompleteProgressBar
